import { CommonState } from "../state";

import { Region } from "./region.model";

/**
 * @deprecated [fabric-deprecated] - use fabric RegionService from svc-content instead
 */
export namespace RegionSelector {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.Regions)" instead
	 */
	export const getAll = (state: CommonState): Region[] | undefined =>
		state.region.regions?.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
}
